module.exports = __webpack_public_path__ + "img/highlights1-s.e998583d.png";